// extracted by mini-css-extract-plugin
module.exports = {"introduction":"clinical-portal-3__CarePlanSectionView__introduction","goalsAndActionsTags":"clinical-portal-3__CarePlanSectionView__goalsAndActionsTags"};